/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MTP Service Mobile API
 * API REST pour l'espace client mobile - Migration Symfony 7.3
 * OpenAPI spec version: 2.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CategoryDashboardResponse,
  ContractsCountResponse,
  ContractsDashboardResponse,
  ContractsListingResponse,
  DashboardResponse,
  EvolutionDashboardResponse,
  GetApiDashboard401,
  GetApiDashboard403,
  GetApiDashboardByCategory401,
  GetApiDashboardByCategory403,
  GetApiDashboardContrats401,
  GetApiDashboardContrats403,
  GetApiDashboardEvo401,
  GetApiDashboardEvo403,
  GetApiDashboardListingContrats401,
  GetApiDashboardListingContrats403,
  GetApiDashboardListingContratsCount401,
  GetApiDashboardListingContratsCount403,
} from '../placementApi.schemas.ts';

import getApiDashboardByCategoryMutator from '.././mutator/placement-instance.ts';
import getApiDashboardContratsMutator from '.././mutator/placement-instance.ts';
import getApiDashboardMutator from '.././mutator/placement-instance.ts';
import getApiDashboardEvoMutator from '.././mutator/placement-instance.ts';
import getApiDashboardListingContratsMutator from '.././mutator/placement-instance.ts';
import getApiDashboardListingContratsCountMutator from '.././mutator/placement-instance.ts';

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Recuperation de l'ensemble des elements pour la gestion du tableau de bord par categorie de l'application mobile
 * @summary Recuperation du tableau de bord par categorie
 */
export const getApiDashboardByCategory = (
  category: 'assurancevie' | 'retraite' | 'defiscalisation' | 'immobilier' | 'livret' | 'bourse',
  signal?: AbortSignal
) => {
  return getApiDashboardByCategoryMutator<CategoryDashboardResponse | void>({
    url: `/api/dashboard/${category}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiDashboardByCategoryQueryKey = (
  category: 'assurancevie' | 'retraite' | 'defiscalisation' | 'immobilier' | 'livret' | 'bourse'
) => {
  return [`/api/dashboard/${category}`] as const;
};

export const getGetApiDashboardByCategoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDashboardByCategory>>,
  TError = GetApiDashboardByCategory401 | GetApiDashboardByCategory403,
>(
  category: 'assurancevie' | 'retraite' | 'defiscalisation' | 'immobilier' | 'livret' | 'bourse',
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardByCategory>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiDashboardByCategoryQueryKey(category);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDashboardByCategory>>> = ({ signal }) =>
    getApiDashboardByCategory(category, signal);

  return {
    queryKey,
    queryFn,
    enabled: category !== null && category !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardByCategory>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiDashboardByCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDashboardByCategory>>>;
export type GetApiDashboardByCategoryQueryError = GetApiDashboardByCategory401 | GetApiDashboardByCategory403;

export function useGetApiDashboardByCategory<
  TData = Awaited<ReturnType<typeof getApiDashboardByCategory>>,
  TError = GetApiDashboardByCategory401 | GetApiDashboardByCategory403,
>(
  category: 'assurancevie' | 'retraite' | 'defiscalisation' | 'immobilier' | 'livret' | 'bourse',
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardByCategory>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDashboardByCategory>>,
          TError,
          Awaited<ReturnType<typeof getApiDashboardByCategory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDashboardByCategory<
  TData = Awaited<ReturnType<typeof getApiDashboardByCategory>>,
  TError = GetApiDashboardByCategory401 | GetApiDashboardByCategory403,
>(
  category: 'assurancevie' | 'retraite' | 'defiscalisation' | 'immobilier' | 'livret' | 'bourse',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardByCategory>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDashboardByCategory>>,
          TError,
          Awaited<ReturnType<typeof getApiDashboardByCategory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDashboardByCategory<
  TData = Awaited<ReturnType<typeof getApiDashboardByCategory>>,
  TError = GetApiDashboardByCategory401 | GetApiDashboardByCategory403,
>(
  category: 'assurancevie' | 'retraite' | 'defiscalisation' | 'immobilier' | 'livret' | 'bourse',
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardByCategory>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation du tableau de bord par categorie
 */

export function useGetApiDashboardByCategory<
  TData = Awaited<ReturnType<typeof getApiDashboardByCategory>>,
  TError = GetApiDashboardByCategory401 | GetApiDashboardByCategory403,
>(
  category: 'assurancevie' | 'retraite' | 'defiscalisation' | 'immobilier' | 'livret' | 'bourse',
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardByCategory>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiDashboardByCategoryQueryOptions(category, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Recuperation de l'ensemble des elements pour la gestion du tableau de bord contrats de l'application mobile
 * @summary Recuperation du tableau de bord contrats
 */
export const getApiDashboardContrats = (signal?: AbortSignal) => {
  return getApiDashboardContratsMutator<ContractsDashboardResponse>({
    url: `/api/dashboard/contrats`,
    method: 'GET',
    signal,
  });
};

export const getGetApiDashboardContratsQueryKey = () => {
  return [`/api/dashboard/contrats`] as const;
};

export const getGetApiDashboardContratsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDashboardContrats>>,
  TError = GetApiDashboardContrats401 | GetApiDashboardContrats403,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardContrats>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiDashboardContratsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDashboardContrats>>> = ({ signal }) =>
    getApiDashboardContrats(signal);

  return { queryKey, queryFn, staleTime: 1800000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDashboardContrats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiDashboardContratsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDashboardContrats>>>;
export type GetApiDashboardContratsQueryError = GetApiDashboardContrats401 | GetApiDashboardContrats403;

export function useGetApiDashboardContrats<
  TData = Awaited<ReturnType<typeof getApiDashboardContrats>>,
  TError = GetApiDashboardContrats401 | GetApiDashboardContrats403,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardContrats>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDashboardContrats>>,
          TError,
          Awaited<ReturnType<typeof getApiDashboardContrats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDashboardContrats<
  TData = Awaited<ReturnType<typeof getApiDashboardContrats>>,
  TError = GetApiDashboardContrats401 | GetApiDashboardContrats403,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardContrats>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDashboardContrats>>,
          TError,
          Awaited<ReturnType<typeof getApiDashboardContrats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDashboardContrats<
  TData = Awaited<ReturnType<typeof getApiDashboardContrats>>,
  TError = GetApiDashboardContrats401 | GetApiDashboardContrats403,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardContrats>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation du tableau de bord contrats
 */

export function useGetApiDashboardContrats<
  TData = Awaited<ReturnType<typeof getApiDashboardContrats>>,
  TError = GetApiDashboardContrats401 | GetApiDashboardContrats403,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardContrats>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiDashboardContratsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Recuperation de l'ensemble des elements pour la gestion du tableau de bord principal de l'application mobile
 * @summary Recuperation du tableau de bord principal
 */
export const getApiDashboard = (signal?: AbortSignal) => {
  return getApiDashboardMutator<DashboardResponse>({ url: `/api/dashboard`, method: 'GET', signal });
};

export const getGetApiDashboardQueryKey = () => {
  return [`/api/dashboard`] as const;
};

export const getGetApiDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDashboard>>,
  TError = GetApiDashboard401 | GetApiDashboard403,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboard>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiDashboardQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDashboard>>> = ({ signal }) => getApiDashboard(signal);

  return { queryKey, queryFn, staleTime: 1800000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDashboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDashboard>>>;
export type GetApiDashboardQueryError = GetApiDashboard401 | GetApiDashboard403;

export function useGetApiDashboard<
  TData = Awaited<ReturnType<typeof getApiDashboard>>,
  TError = GetApiDashboard401 | GetApiDashboard403,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboard>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDashboard>>,
          TError,
          Awaited<ReturnType<typeof getApiDashboard>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDashboard<
  TData = Awaited<ReturnType<typeof getApiDashboard>>,
  TError = GetApiDashboard401 | GetApiDashboard403,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboard>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDashboard>>,
          TError,
          Awaited<ReturnType<typeof getApiDashboard>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDashboard<
  TData = Awaited<ReturnType<typeof getApiDashboard>>,
  TError = GetApiDashboard401 | GetApiDashboard403,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboard>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation du tableau de bord principal
 */

export function useGetApiDashboard<
  TData = Awaited<ReturnType<typeof getApiDashboard>>,
  TError = GetApiDashboard401 | GetApiDashboard403,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboard>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiDashboardQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Recuperation de l'ensemble des elements pour la gestion du tableau de bord principal de l'application mobile
 * @summary Recuperation du tableau de bord principal (evolution)
 */
export const getApiDashboardEvo = (signal?: AbortSignal) => {
  return getApiDashboardEvoMutator<EvolutionDashboardResponse>({ url: `/api/dashboard/evo`, method: 'GET', signal });
};

export const getGetApiDashboardEvoQueryKey = () => {
  return [`/api/dashboard/evo`] as const;
};

export const getGetApiDashboardEvoQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDashboardEvo>>,
  TError = GetApiDashboardEvo401 | GetApiDashboardEvo403,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardEvo>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiDashboardEvoQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDashboardEvo>>> = ({ signal }) =>
    getApiDashboardEvo(signal);

  return { queryKey, queryFn, staleTime: 1800000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDashboardEvo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiDashboardEvoQueryResult = NonNullable<Awaited<ReturnType<typeof getApiDashboardEvo>>>;
export type GetApiDashboardEvoQueryError = GetApiDashboardEvo401 | GetApiDashboardEvo403;

export function useGetApiDashboardEvo<
  TData = Awaited<ReturnType<typeof getApiDashboardEvo>>,
  TError = GetApiDashboardEvo401 | GetApiDashboardEvo403,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardEvo>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDashboardEvo>>,
          TError,
          Awaited<ReturnType<typeof getApiDashboardEvo>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDashboardEvo<
  TData = Awaited<ReturnType<typeof getApiDashboardEvo>>,
  TError = GetApiDashboardEvo401 | GetApiDashboardEvo403,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardEvo>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDashboardEvo>>,
          TError,
          Awaited<ReturnType<typeof getApiDashboardEvo>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDashboardEvo<
  TData = Awaited<ReturnType<typeof getApiDashboardEvo>>,
  TError = GetApiDashboardEvo401 | GetApiDashboardEvo403,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardEvo>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation du tableau de bord principal (evolution)
 */

export function useGetApiDashboardEvo<
  TData = Awaited<ReturnType<typeof getApiDashboardEvo>>,
  TError = GetApiDashboardEvo401 | GetApiDashboardEvo403,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardEvo>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiDashboardEvoQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Recuperation de l'ensemble des elements pour la gestion des operations de reversement
 * @summary Recuperation de la liste des contrats sous forme simple
 */
export const getApiDashboardListingContrats = (signal?: AbortSignal) => {
  return getApiDashboardListingContratsMutator<ContractsListingResponse>({
    url: `/api/dashboard/listingcontrats`,
    method: 'GET',
    signal,
  });
};

export const getGetApiDashboardListingContratsQueryKey = () => {
  return [`/api/dashboard/listingcontrats`] as const;
};

export const getGetApiDashboardListingContratsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDashboardListingContrats>>,
  TError = GetApiDashboardListingContrats401 | GetApiDashboardListingContrats403,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardListingContrats>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiDashboardListingContratsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDashboardListingContrats>>> = ({ signal }) =>
    getApiDashboardListingContrats(signal);

  return { queryKey, queryFn, staleTime: 1800000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDashboardListingContrats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiDashboardListingContratsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDashboardListingContrats>>
>;
export type GetApiDashboardListingContratsQueryError =
  GetApiDashboardListingContrats401 | GetApiDashboardListingContrats403;

export function useGetApiDashboardListingContrats<
  TData = Awaited<ReturnType<typeof getApiDashboardListingContrats>>,
  TError = GetApiDashboardListingContrats401 | GetApiDashboardListingContrats403,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardListingContrats>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDashboardListingContrats>>,
          TError,
          Awaited<ReturnType<typeof getApiDashboardListingContrats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDashboardListingContrats<
  TData = Awaited<ReturnType<typeof getApiDashboardListingContrats>>,
  TError = GetApiDashboardListingContrats401 | GetApiDashboardListingContrats403,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardListingContrats>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDashboardListingContrats>>,
          TError,
          Awaited<ReturnType<typeof getApiDashboardListingContrats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDashboardListingContrats<
  TData = Awaited<ReturnType<typeof getApiDashboardListingContrats>>,
  TError = GetApiDashboardListingContrats401 | GetApiDashboardListingContrats403,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardListingContrats>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation de la liste des contrats sous forme simple
 */

export function useGetApiDashboardListingContrats<
  TData = Awaited<ReturnType<typeof getApiDashboardListingContrats>>,
  TError = GetApiDashboardListingContrats401 | GetApiDashboardListingContrats403,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardListingContrats>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiDashboardListingContratsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Recuperation du nombre de contrats par famille pour la gestion des operations de reversement
 * @summary Recuperation du nombre de contrats par famille
 */
export const getApiDashboardListingContratsCount = (signal?: AbortSignal) => {
  return getApiDashboardListingContratsCountMutator<ContractsCountResponse>({
    url: `/api/dashboard/listingcontrats/count`,
    method: 'GET',
    signal,
  });
};

export const getGetApiDashboardListingContratsCountQueryKey = () => {
  return [`/api/dashboard/listingcontrats/count`] as const;
};

export const getGetApiDashboardListingContratsCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>,
  TError = GetApiDashboardListingContratsCount401 | GetApiDashboardListingContratsCount403,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiDashboardListingContratsCountQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>> = ({ signal }) =>
    getApiDashboardListingContratsCount(signal);

  return { queryKey, queryFn, staleTime: 1800000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiDashboardListingContratsCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>
>;
export type GetApiDashboardListingContratsCountQueryError =
  GetApiDashboardListingContratsCount401 | GetApiDashboardListingContratsCount403;

export function useGetApiDashboardListingContratsCount<
  TData = Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>,
  TError = GetApiDashboardListingContratsCount401 | GetApiDashboardListingContratsCount403,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>,
          TError,
          Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDashboardListingContratsCount<
  TData = Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>,
  TError = GetApiDashboardListingContratsCount401 | GetApiDashboardListingContratsCount403,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>,
          TError,
          Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiDashboardListingContratsCount<
  TData = Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>,
  TError = GetApiDashboardListingContratsCount401 | GetApiDashboardListingContratsCount403,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation du nombre de contrats par famille
 */

export function useGetApiDashboardListingContratsCount<
  TData = Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>,
  TError = GetApiDashboardListingContratsCount401 | GetApiDashboardListingContratsCount403,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiDashboardListingContratsCount>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiDashboardListingContratsCountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
